import {
  useMutation,
  UseMutationOptions,
  useQuery,
  useQueryClient
} from "@tanstack/react-query";
import {
  EditFeatureFlagRequest,
  EditFeatureFlagResponse,
  GetFeatureFlagsResponse,
  editFeatureFlag,
  getFeatureFlags,
  getFeatureFlag,
} from "../api/featureFlag";
import FeatureFlag from "../types/feature-flags/featureFlag";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

export const useFeatureFlag = (
  customerId: string | undefined,
  featureName: string | undefined
) => {
  return useQuery<FeatureFlag | undefined, Error>({
    queryKey: ["feature-flag", customerId, featureName],
    queryFn: () => getFeatureFlag(customerId!, featureName!),
    enabled: !!customerId && !!featureName,
  });
};

export const useFeatureFlags = () => {
  return useQuery<GetFeatureFlagsResponse, Error>({
    queryKey: ["feature-flags"],
    queryFn: () => getFeatureFlags(),
  });
};

export const useEditFeatureFlag = () => {
  const queryClient = useQueryClient();
  const mutationOptions: UseMutationOptions<
    EditFeatureFlagResponse,
    Error,
    EditFeatureFlagRequest
  > = {
    mutationFn: (request: EditFeatureFlagRequest) => {
      return editFeatureFlag(request);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["feature-flags"] });
    },
  };
  return useMutation(mutationOptions);
};

export const useFeatureFlagToken = (flagName: string): boolean => {
  const { user } = useContext(AuthContext);
  return user?.hasFeatureFlag(flagName) ?? false;
};
